import { typographyTokens } from '../../../../theme/typographyTokens';


import React, { useMemo } from 'react';
import Box from '@mui/material/Box/Box';
import { useTheme } from '@mui/material/styles';
import { transformQuillListToNested, nestedListStyles } from '../../../../utils/quillHtmlTransform';

export default function PreviewNotification( {body} : {body: string}) {
    const theme = useTheme();
    
    // Transform Quill's flat list structure to proper nested HTML
    const transformedBody = useMemo(() => transformQuillListToNested(body), [body]);
    
    return (
        <Box
            sx={{
                background: theme.palette.mode === 'dark' ? theme.palette.background.default : "#f3f3f3",
                borderRadius: 1,
                p: 2,
                minHeight: 100,
                color: theme.palette.mode === 'dark' ? theme.palette.white.main : theme.palette.black.main,
                overflowY: "auto",
                fontSize: typographyTokens.fontSizes.h6,
                fontFamily: "'Segoe UI', Arial, sans-serif",
                // whiteSpace: "pre-wrap",
                ...nestedListStyles,
            }}
            dangerouslySetInnerHTML={{ __html: transformedBody }}
        />
    );
}